import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
// import OutsideClickHandler from "react-outside-click-handler";
import {
  getSingleResidentialUser
} from "../../lib/data";
import ReactToPrint from "react-to-print";

import arrow from "../../images/svg/arrow-back.svg";
import arrow2 from "../../images/svg/arrow-down.svg";
import arrow3 from "../../images/svg/arrow-dwn-purple.svg";
import download from "../../images/svg/download.svg";
import Loader from "../Loader";
import axios from "axios";

function Talentresidentdetails({setTabOption}) {
  const [clicked, setClicked] = useState("bio");
  const [userDetails, setUserDetails] = useState();
  const [showDownload, setShowDownload] = useState(false);
  const [downloadHtml, setDownloadHtml] = useState(null);
  const urlParams = new URLSearchParams(window.location.search);
  const user_id = urlParams.get("user");


  useEffect(() => {
    getSingleResidentialUser(user_id)
      .then((response) => {
        // console.log(response)
        if (response.status === 200) {
          setUserDetails(response.data.data.data);
        } else {
          window.location.reload();
        }
      })
      .catch((err) => {
        // console.log(err.response);
        if (err.response) {
          toast.error(err.response);
        } else {
          toast.error(
            "Something went wrong!!! Please make sure you have a good internet connection."
          );
        }
      });
  }, []);

    const downloadResp = (resp) => {
    setDownloadHtml(resp);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getUTCFullYear();
    const suffix = day % 10 === 1 && day !== 11 ? 'st' :
                   day % 10 === 2 && day !== 12 ? 'nd' :
                   day % 10 === 3 && day !== 13 ? 'rd' : 'th';
    return `${day}${suffix} ${month}, ${year}`;
}

  return (
    <div>
      {userDetails ? (
        <div className="dashboard-content">
          <ToastContainer closeButton={false} />
          <div
            className="dashboard-content-back"
            onClick={() => {window.history.back()
              setTabOption('residency')
            }}
          >
            <img src={arrow} alt="back" />
            <p>Back</p>
          </div>
          <div className="disp-flex dashboard-content-detail-actions">
            <div></div>
            <h3>
              {userDetails.fullName}
            </h3>
            <div className="disp-flex dashboard-content-actions-div">
              <ReactToPrint
                content={() => downloadHtml}
                trigger={() => <p>Download Data</p>}
              />
              <div className="pos-rel">
                {showDownload && (
                    <div className="dashboard-content-actions-byStatus new-option">
                      <ReactToPrint
                        content={() => downloadHtml}
                        trigger={() => (
                          <div className="status">
                            <label htmlFor="under-review">Bio Data</label>
                            <img
                              src={download}
                              alt="download"
                              style={{ marginLeft: "auto" }}
                            />
                          </div>
                        )}
                      />
                    </div>
                )}
              </div>
            </div>
          </div>
          <div className="dashboard-content-detail">
            <p
              className={
                clicked === "bio"
                  ? "dashboard-content-detail-p active"
                  : "dashboard-content-detail-p"
              }
              onClick={() => setClicked("bio")}
            >
              Bio Data
            </p>
          </div>
          {clicked === "bio" && (
            <div
              className="dashboard-content-form"
              id="noshadow"
              ref={(response) => downloadResp(response)}
            >
              <form>
                <div className="dashboard-content-form-container">
                  <h5 className="heading">Full Name</h5>
                  <p className="text">{userDetails?.fullName}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5 className="heading">Email Address</h5>
                  <p className="text">{userDetails?.email}</p>
                </div>
                {/* <hr /> */}
                <div className="dashboard-content-form-container">
                  <h5 className="heading">Phone Number</h5>
                  <p className="text">{userDetails?.phoneNumber}</p>
                </div>
                {/* <hr /> */}
                <div className="dashboard-content-form-container">
                  <h5 className="heading">Profession</h5>
                  <p className="text">{userDetails?.profession}</p>
                </div>
                {/* <hr /> */}
                <div className="dashboard-content-form-container">
                  <h5 className="heading">Reason for Residency Interest</h5>
                  <p className="text">{userDetails?.interest}</p>
                </div>
                {/* <hr /> */}
                <div className="dashboard-content-form-container">
                  <h5 className="heading">Type of residence</h5>
                  <p className="text">{userDetails?.residentType}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5 className="heading">Preferred move-in date</h5>
                  <p className="text">{userDetails?.moveInDate && formatDate(userDetails?.moveInDate)}</p>
                </div>
                {/* <hr /> */}
                <div className="dashboard-content-form-container">
                  <h5 className="heading">Inspection Fee</h5>
                  <p className="text fee paid">{userDetails?.inspectionFee ? 'paid' : ''}</p>
                </div>
              </form>
            </div>
          )}
          
          
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
}

export default Talentresidentdetails;
